import { DGDashboardAPIResponse, MetricDescription } from './types'

export function extractMetrics(data: DGDashboardAPIResponse) {
  const result: {
    dimension: string
    metric: string
    score: number
    description: string
    purpose: string
  }[] = []

  Object.entries(data).forEach(([category, value]) => {
    if (
      value &&
      typeof value === 'object' &&
      'metrics' in value &&
      'metric_descriptions' in value
    ) {
      const { metrics, metric_descriptions } = value as {
        metrics: Record<string, number>
        metric_descriptions: MetricDescription[]
      }

      Object.entries(metrics).forEach(([metricKey, metricValue]) => {
        if (metricKey !== 'entity_id' && typeof metricValue === 'number') {
          const descriptionEntry = metric_descriptions.find((desc) => desc.key === metricKey)

          result.push({
            dimension:
              category === 'sensitivity' ? 'Sensitivity & Risk' : formatMetricName(category),
            metric: formatMetricName(metricKey),
            score: parseFloat(metricValue.toFixed(2)),
            description: descriptionEntry?.description || '',
            purpose: descriptionEntry?.purpose || '',
          })
        }
      })
    }
  })

  return result
}

export function formatMetricName(metricKey: string): string {
  const ACRONYMS = ['PII', 'DQ', 'ID']

  if (!metricKey) return ''

  let formatted = metricKey
    .replace(/_/g, ' ') // replace underscores with spaces
    .replace(/\s+/g, ' ') // collapse multiple spaces
    .trim()
    .split(' ') // split into words
    .map((word) => {
      const upper = word.toUpperCase()
      return ACRONYMS.includes(upper)
        ? upper
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')

  return formatted
}

export function getStyles(score: number): { text: string; progress: string; bg: string } {
  if (score < 75) {
    return {
      text: 'text-red-600',
      progress: 'bg-red-600',
      bg: 'bg-red-600',
    }
  }
  if (score > 74 && score < 90) {
    return {
      text: 'text-amber-800',
      progress: 'bg-amber-600',
      bg: 'bg-amber-600',
    }
  }
  return {
    text: 'text-green-800',
    progress: 'bg-green-600',
    bg: 'bg-green-600',
  }
}
